export default "__VITE_ASSET__83f084e1__"